import { SupplierVoucherWebService } from '@linktivity/gds-neo';

export const Language = SupplierVoucherWebService.Language;
export type Language = SupplierVoucherWebService.Language;
